/**
 * Estructura de contenido dinámico
 * Esta estructura simula la respuesta que vendrá de Strapi
 * y permite hacer el sitio completamente dinámico
 */

export const siteContent = {
  // Configuración global del sitio
  site: {
    name: "GIOR",
    description: "Sistema de gestión de citas para negocios pequeños",
    logo: {
      icon: "CalendarIcon", // Heroicon name
      alt: "Logo GIOR"
    }
  },

  // Navegación principal
  navigation: {
    main: [
      {
        id: "home",
        label: "Inicio",
        path: "/",
        requireAuth: false
      },
      {
        id: "dashboard", 
        label: "Dashboard",
        path: "/dashboard",
        requireAuth: true
      }
    ],
    auth: {
      login: {
        label: "Inicio de Sesión",
        path: "/login"
      },
      register: {
        label: "Pruébalo Gratis",
        path: "/register"
      },
      logout: {
        label: "Cerrar Sesión"
      }
    }
  },

  // Sección Hero
  hero: {
    title: {
      main: "Gestiona tus citas",
      highlight: "de forma inteligente"
    },
    description: "La solución completa para administrar las citas de tu negocio. Agenda, gestiona clientes y servicios desde una sola plataforma.",
    buttons: {
      primary: {
        guest: {
          label: "Pruébalo Gratis",
          action: "register"
        },
        authenticated: {
          label: "Ir al Dashboard", 
          action: "dashboard"
        }
      },
      secondary: {
        label: "Ver Demo",
        action: "demo"
      }
    },
    stats: [
      {
        id: "availability",
        value: "24/7",
        label: "Disponibilidad"
      },
      {
        id: "security",
        value: "100%", 
        label: "Seguro"
      },
      {
        id: "appointments",
        value: "∞",
        label: "Citas"
      }
    ]
  },

  // ✅ EJEMPLO: Nueva sección Features
  features: {
    title: "Características Principales",
    subtitle: "Todo lo que necesitas para gestionar tu negocio",
    items: [
      {
        id: "calendar",
        title: "Calendario Inteligente",
        description: "Gestiona todas tus citas con un calendario visual e intuitivo. Arrastra y suelta para reprogramar.",
        icon: "CalendarIcon",
        image: "/images/feature-calendar.jpg"
      },
      {
        id: "clients",
        title: "Base de Clientes",
        description: "Organiza la información de tus clientes, historial de citas y preferencias en un solo lugar.",
        icon: "UsersIcon",
        image: "/images/feature-clients.jpg"
      },
      {
        id: "notifications",
        title: "Notificaciones Automáticas",
        description: "Envía recordatorios automáticos por SMS, email y WhatsApp. Reduce las cancelaciones.",
        icon: "BellIcon",
        image: "/images/feature-notifications.jpg"
      }
    ]
  },

  // ✅ EJEMPLO: Nueva sección Testimonials
  testimonials: {
    title: "Lo que dicen nuestros clientes",
    subtitle: "Más de 1,000 negocios confían en nosotros",
    items: [
      {
        id: "testimonial-1",
        name: "Juan Pérez",
        company: "Clínica Dental XYZ",
        text: "GIOR cambió la forma en que manejo mis citas. Ahora tengo más tiempo para atender a mis pacientes.",
        avatar: "/images/avatar-juan.jpg",
        rating: 5
      },
      {
        id: "testimonial-2", 
        name: "María González",
        company: "Salón de Belleza Luna",
        text: "Las notificaciones automáticas redujeron mis cancelaciones en un 70%. ¡Increíble!",
        avatar: "/images/avatar-maria.jpg",
        rating: 5
      }
    ]
  },

  // Footer
  footer: {
    copyright: {
      year: 2025,
      company: "GIOR",
      description: "Sistema de gestión de citas para negocios pequeños"
    },
    links: [
      {
        id: "terms",
        label: "Términos y Condiciones",
        path: "/terminos-y-condiciones"
      },
      {
        id: "privacy",
        label: "Política de Privacidad",
        path: "/privacidad"
      }
    ]
  },

  // Meta información para SEO (cuando se conecte con Strapi)
  meta: {
    title: "GIOR - Sistema de gestión de citas",
    description: "La solución completa para administrar las citas de tu negocio. Agenda, gestiona clientes y servicios desde una sola plataforma.",
    keywords: ["gestión", "citas", "agenda", "negocios", "clientes"],
    ogImage: "/images/og-image.jpg"
  }
}
